import { render, staticRenderFns } from "./AboutInfoBlock.vue?vue&type=template&id=34d296e5&scoped=true&"
import script from "./AboutInfoBlock.vue?vue&type=script&lang=js&"
export * from "./AboutInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./AboutInfoBlock.vue?vue&type=style&index=0&id=34d296e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d296e5",
  null
  
)

export default component.exports